import * as React from 'react';
import { Redirect } from 'react-router';
import { fetchRefreshToken } from '../logic/api/BizServer';
import Loading from './Loading';
interface Props {
  search: string;
  refreshToken: string;
  setRefreshToken: (code: string) => void;
}

interface State {
  isLoading: boolean;
}

class Callback extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: true
    };
  }

  async componentDidMount() {
    const code = `${parseCode(this.props.search)}#`;
    const token = await fetchRefreshToken(code);
    this.props.setRefreshToken(token);
    this.setState({
      isLoading: false
    });
  }

  render() {
    return this.state.isLoading ? <Loading /> : <Redirect to="/" />;
  }
}

const parseCode = (url: string): string => {
  if (url.length < 1) {
    return '';
  }
  const queryString = url.split('?')[1];
  if (!queryString) {
    return '';
  }
  const paramValue = queryString.split('=')[1];
  if (!paramValue) {
    return '';
  }
  return paramValue;
};

export default Callback;



// WEBPACK FOOTER //
// ./src/components/Callback.tsx